module.exports = "https://static.zego.com/_next/static/images/opengraph-uk-97d191ab099878b69e0f0927e59ef605.png";